export default defineNuxtRouteMiddleware(async (to, from) => {
  const authStore = useAuthStore();

  // If partner and no customerId, redirect to select customer page
  if (authStore.isPartner && !authStore.customerId) {
    if (to.name === "velg-kunde") {
      return abortNavigation(
        "Loop prevented - this middleware should not be used on the velg-kunde page"
      );
    }

    return await navigateTo({
      path: "/velg-kunde",
    });
  }
});
